import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Row,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import CommonFileUpload from "../../../component/common/CommonFileUpload";
import { UL, LI, H5 } from "../../../AbstractElements";
 import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";
 
const ImportHolidayTypePage: React.FC = () => {
  const { t } = useTranslation();

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch(
        `/templates/holiday-type-template.xlsx?t=${new Date().getTime()}`,
        {
          method: "GET",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const contentType = response.headers.get("Content-Type");
      if (
        contentType !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        throw new Error(`Unexpected content type: ${contentType}`);
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "holiday-type-template.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const navigate = useNavigate();

  const handleFileUpload = (files: File[]) => {
    const excelFiles = files.filter(
      (file) =>
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
    if (excelFiles.length > 0) {
      setUploadedFiles(excelFiles);
    } else {
      alert("Please upload only Excel files (.xls, .xlsx).");
    }
  };

  const handleRemoveFile = (indexToRemove: number) => {
    setUploadedFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleCancel = () => {
    setUploadedFiles([]);
    navigate(`${process.env.PUBLIC_URL}/masterdata/holiday-type`);
  };

  const handleImport = () => {
    // logic to import excel file
  };

  return (
    <div className="page-body" style={{ marginLeft: "246px" }}>
      <Breadcrumbs
        mainTitle={t("Import Holiday Type")}
        parents={[
          {
            label: t("Master Data"),
            link: `${process.env.PUBLIC_URL}/masterdata`,
          },
          {
            label: t("HolidayType"),
            link: `${process.env.PUBLIC_URL}/masterdata/holiday-type`,
          },
        ]}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card className="custom-list-group shadow-sm border-0">
              <Col sm="12" className="d-flex justify-content-between">
                <CardHeaderCommon
                  title={t("ImportHolidayTypeInstructions")}
                  headClass="card-no-border"
                />
                <Button
                  color="primary"
                  className="mt-3 me-3"
                  onClick={handleDownloadTemplate}
                >
                  {t("DownloadTemplate")}
                </Button>
              </Col>
              <CardBody className="py-3">
                <UL className="list-content">
                  <LI>
                    <i className="icofont icofont-arrow-right" />
                    {t("UseStandardExcelFormat")} (xlsx, csv, and different
                    Excel formats)
                  </LI>
                  <LI>
                    <i className="icofont icofont-arrow-right" />
                    Ensure the file contains required columns: Type Name,
                    Description
                  </LI>
                  <LI>
                    <i className="icofont icofont-arrow-right" />
                    {t("MaxFileSize", { size: "5MB" })}
                  </LI>
                </UL>

                <H5 className="mt-3">Select File</H5>
                <Col sm="4" className="mt-3">
                  <FormGroup>
                    <CommonFileUpload
                      multiple={false}
                      uploadedFiles={uploadedFiles}
                      onFileUpload={handleFileUpload}
                      onRemoveFile={handleRemoveFile}
                    />
                  </FormGroup>
                </Col>
                <div className="text-end mt-3">
                  <Button
                    color="secondary"
                    className="me-2"
                    onClick={handleCancel}
                  >
                    {t("Cancel")}
                  </Button>
                  <Button
                    color="success"
                    onClick={handleImport}
                    disabled={uploadedFiles.length === 0}
                    className={
                      uploadedFiles.length === 0 ? "cursor-not-allowed" : ""
                    }
                  >
                    {t("Import")}
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ImportHolidayTypePage;
